import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-copy-profile-admon',
  templateUrl: './dialog-copy-profile-admon.component.html',
  styleUrls: ['./dialog-copy-profile-admon.component.scss']
})
export class DialogCopyProfileAdmonComponent implements OnInit {
  form: FormGroup;

  constructor(private fb: FormBuilder,
              private dialogRef: MatDialogRef<DialogCopyProfileAdmonComponent>,
              @Inject(MAT_DIALOG_DATA) public data: { name: string }) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      name: [this.data.name || '', [Validators.required, Validators.maxLength(37)]]
    });
  }

  accept(): void {
    if (this.form.valid) {
      this.dialogRef.close(this.form.value.name);
    }
  }

  cancel(): void {
    this.dialogRef.close();
  }

}
